import z from "zod";
import { OrganizationIdSchema, ProjectIdSchema, WorkspaceIdSchema } from "./idTypes";

export const TenancySchema = z.object({
  tenantId: OrganizationIdSchema,
  organizationId: OrganizationIdSchema,
  workspaceId: WorkspaceIdSchema.optional(),
  projectId: ProjectIdSchema.optional(),
});
export type Tenancy = z.infer<typeof TenancySchema>;
